import { ErrorBoundary } from '@datadog/browser-rum-react'
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6'
import { setLDClient } from 'feature_flags/FeatureFlagUtils'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import ErrorPage from 'pages/ErrorPage'
import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import Root from 'routes/Root'

import RootProvider from 'components/providers/RootProvider'

const router = createBrowserRouter([
  {
    path: '*',
    element: <Root />,
  },
])

function App() {
  const ldClient = useLDClient()

  useEffect(() => {
    if (ldClient) {
      setLDClient(ldClient)
    }
  }, [ldClient])
  return (
    <ErrorBoundary fallback={ErrorPage}>
      <RootProvider>
        <RouterProvider router={router} />
      </RootProvider>
    </ErrorBoundary>
  )
}

export default App
